// extracted by mini-css-extract-plugin
export default {"steps":"Steps__steps-rkrA","stepsCard":"Steps__stepsCard-hBNC","innerSvg":"Steps__innerSvg-JmjJ"};